jQuery(function() {
  var $ = jQuery;
  $("#toast-box .close-button").click(function() {
    $.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      data: { action: "toastBoxClose" },
      success: function() {}
    });
  });
});
